import { Button, ButtonProps } from "..";

export const UpdateButton = (
  props: ButtonProps & {
    label?: string;
  }
) => {
  const { label, onClick, ...rest } = props;

  return (
    <Button variant={"outlined"} onClick={onClick} {...rest}>
      {label || "Edit"}
    </Button>
  );
};
